import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, emailUrl } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What&apos;s Next?</h2>

      <h2 className="title">Let&apos;s Talk</h2>

      <p>
        Have a product idea, a practical AI problem, or a thoughtful take on where an LLM fails?
        Send a note. Rahul reads every genuine message. You can also connect on{' '}
        <a href="https://www.linkedin.com/in/rahulrathnavel/" target="_blank" rel="noreferrer">
          LinkedIn
        </a>{' '}
        or explore the code on{' '}
        <a href="https://github.com/rahulrathnavel" target="_blank" rel="noreferrer">
          GitHub
        </a>
        .
      </p>

      <a className="email-link" href={emailUrl} target="_blank" rel="noopener noreferrer">
        Send an email
      </a>
    </StyledContactSection>
  );
};

export default Contact;
